import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            component: HomeView,
            meta: { requiresAuth: true }
        },
        {
            path: '/attendance',

            name: 'attendance',
            component: () => import('../views/AttendanceView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/team-attendance',
            name: 'team-attendance',
            component: () => import('../views/TeamAttendanceView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/history',

            name: 'history',
            component: () => import('../views/HistoryView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/requests',

            name: 'requests',
            component: () => import('../views/RequestView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/expense-claims',

            name: 'expense-claims',
            component: () => import('../views/ExpenseClaimView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/fundraising',

            name: 'fundraising',
            component: () => import('../views/FundraisingView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile',

            name: 'profile',
            component: () => import('../views/ProfileView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/family',
            name: 'family-list',
            component: () => import('../views/profile/FamilyView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/family/add',
            name: 'family-add',
            component: () => import('../views/profile/FamilyFormView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/education',
            name: 'education-list',
            component: () => import('../views/profile/EducationView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/education/add',
            name: 'education-add',
            component: () => import('../views/profile/EducationFormView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/certification',
            name: 'certification-list',
            component: () => import('../views/profile/CertificationView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/certification/add',
            name: 'certification-add',
            component: () => import('../views/profile/CertificationFormView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/bpjs',
            name: 'bpjs-view',
            component: () => import('../views/profile/BpjsView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/bpjs/edit',
            name: 'bpjs-edit',
            component: () => import('../views/profile/BpjsFormView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/bank-account',
            name: 'account-list',
            component: () => import('../views/profile/AccountView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/profile/bank-account/add',
            name: 'account-add',
            component: () => import('../views/profile/AccountFormView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/inbox',
            name: 'inbox',
            component: () => import('../views/InboxView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/login',
            name: 'login',
            component: LoginView,
            meta: { guest: true }
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: () => import('../views/ForgotPasswordView.vue'),
            meta: { guest: true }
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: () => import('../views/ResetPasswordView.vue'),
            meta: { guest: true }
        },
        {
            path: '/change-password',
            name: 'change-password',
            component: () => import('../views/ChangePasswordView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/approvals',
            name: 'approvals',
            component: () => import('../views/ApprovalView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/visits',
            name: 'visits',
            component: () => import('../views/visits/VisitDashboard.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/visits/create',
            name: 'visits-create',
            component: () => import('../views/visits/VisitForm.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: () => import('../views/CalendarView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/payslips',
            name: 'payslips',
            component: () => import('../views/PayslipView.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/sop',
            name: 'sop-library',
            component: () => import('../views/SopLibrary.vue'),
            meta: { requiresAuth: true }
        },
        {
            path: '/sop/:id',
            name: 'sop-viewer',
            component: () => import('../views/SopViewer.vue'),
            meta: { requiresAuth: true, hideBottomNav: true }
        },
    ]
})

router.beforeEach((to, _from, next) => {
    const authStore = useAuthStore()

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next({ name: 'login' })
    } else if (to.meta.guest && authStore.isAuthenticated) {
        next({ name: 'home' })
    } else {
        next()
    }
})

export default router
